module.exports = __webpack_public_path__ + "static/img/lpfw_banner.9d7a30f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lpfw_banner.png
// module id = w7qD
// module chunks = 0